import { css } from 'styled-components';

export const DiscountContainerStyles = css`
  #DiscountsContainer {
    .container-controls {
      > div {
        label > div {
          overflow: visible;
        }
      }
    }
  }
`;
